'use es6';

export const getGraphqlFiles = state => state.graphqlFiles;
export const getGraphqlFilesById = state => state.graphqlFiles.byId;
export const getGraphqlFilesByPath = state => state.graphqlFiles.byPath;
export const getGraphqlFilesOrderById = state => state.graphqlFiles.orderById;
export const getGraphqlFilesOptions = state => Object.values(state.graphqlFiles.byId).map(data_query => ({
  text: data_query.label,
  value: data_query.path,
  help: data_query.description
}));